import ageUtil from "@/script/age.js"
function chkDate(paramDate) {
    const year = parseInt(paramDate.slice(0, 4),10);
    const month = parseInt(paramDate.slice(4, 6),10);
    const day = parseInt(paramDate.slice(6, 8),10);
    const chkDate = new Date(year, month-1, day);

    const maxDate = ageUtil.getJstNowDate();
    const minDate = new Date(1901, 0, 1);

    if (month < 1 || month > 12) {
        return false;
    } else if (!(chkDate.getFullYear() === year && chkDate.getMonth() === month - 1 && chkDate.getDate() === day )) {
        return false;
    } else if (chkDate > maxDate || chkDate < minDate) {
        return false;
    } else {
        return true;
    }
}

function chkPlanSekkeiParam(params) {
    if (!params.get("hymd") && !params.get("hs") && !params.get("stp") && !params.get("sts")) {
        return "1";
    } else if (params.get("hymd") && params.get("hs") && params.get("stp") && params.get("sts")) {
        return "2";
    } else {
        return "e";
    }
}

function chkAge(paramRealAge, paramKeiyakujiAge) {
    if (paramRealAge >= 18 && paramKeiyakujiAge <= 49){
        return true;
    } else {
        return false;
    }
}

export default {chkDate, chkPlanSekkeiParam, chkAge}